module.exports = __webpack_public_path__ + "static/media/ChangeSort.f407b611.svg";